import { render, staticRenderFns } from "./TaskNav.vue?vue&type=template&id=6178068c&scoped=true"
import script from "./TaskNav.vue?vue&type=script&lang=js"
export * from "./TaskNav.vue?vue&type=script&lang=js"
import style0 from "./TaskNav.vue?vue&type=style&index=0&id=6178068c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6178068c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6178068c')) {
      api.createRecord('6178068c', component.options)
    } else {
      api.reload('6178068c', component.options)
    }
    module.hot.accept("./TaskNav.vue?vue&type=template&id=6178068c&scoped=true", function () {
      api.rerender('6178068c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Task/TaskNav.vue"
export default component.exports